import Api from '@/services/api';
import qs from 'querystring';
export default {
  overview(total = "no") {
    return Api().get("/overview" + "?total=" + total);
  },
  agenda() {
    return Api().get("/gestion/agenda");
  },
  live(search, negoId) {
    return Api().get(
      "/gestion/live?nego=" + negoId + "&search=" + encodeURIComponent(search)
    );
  },
  dynamic_update(post) {
    return Api().post("/dynamic-update", "data=" + JSON.stringify(post));
  },
  unused() {
    return Api().post("/gestion/warrants-unused");
  },
  waiting() {
    return Api().post("/gestion/warrants-waiting");
  },
  assigned() {
    return Api().post("/gestion/warrants-assigned");
  },
  rappels_emails() {
    return Api().post("/gestion/warrants-settlement-default-emails");
  },
  send_emails() {
    return Api().post("/gestion/warrants-settlement-send-default-emails");
  },
  no_sms(order, sort) {
    return Api().post(
      "/gestion/warrants-no-sms?order=" +
        encodeURIComponent(order) +
        "&sort=" +
        encodeURIComponent(sort)
    );
  },
  sms(order, sort) {
    return Api().post(
      "/gestion/warrants-sms?order=" +
        encodeURIComponent(order) +
        "&sort=" +
        encodeURIComponent(sort)
    );
  },
  vierges(order, sort) {
    return Api().post(
      "/gestion/warrants-without-debtor?order=" +
        encodeURIComponent(order) +
        "&sort=" +
        encodeURIComponent(sort)
    );
  },
  ack: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-acks",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  assignations: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-assignations",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  tribunal: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-tribunal",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  close: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-close",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  canceled: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-canceled",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },

  creditors_without_warrants: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-creditors-without-warrants",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  creditors_to_check: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-creditors-to-check",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  creditors_reminders: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-creditors-reminders",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  creditors_send_login: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-creditors-send-login",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  warrants_without_settlements: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-warrants-without-settlements",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  settlements_in_default: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-settlements-in-default",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  routes: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true,
      parameters = []
    ) {
      return Api().post(
        "/gestion/search-routes",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
          admin: parameters.admin,
          archive: parameters.archive,
          month: parameters.month,
        })
      );
    },
    suppress(id) {
      return Api().delete("/gestion/route/" + id);
    },
  },
  warrants_3_reminders: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-warrants-3-reminders",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  warrants_stopped: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-warrants-stopped",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  warrants_to_check: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-warrants-to-check",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  nego_reminders: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-nego-reminders",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  lawyer_reminders: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true
    ) {
      return Api().post(
        "/gestion/search-lawyer-reminders",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
        })
      );
    },
  },
  reminders: {
    search(
      params,
      filters = [],
      hiddenFilter = "",
      page = 1,
      sortBy = "date",
      sortDesc = false,
      fetchFacets = true,
      parameters = []
    ) {
      return Api().post(
        "/gestion/search-reminders",
        qs.stringify({
          search: JSON.stringify(params),
          filters: JSON.stringify(filters),
          hiddenFilter: hiddenFilter,
          page: page,
          sortBy: sortBy,
          sortDesc: sortDesc,
          fetchFacets: fetchFacets,
          nego: parameters.nego,
        })
      );
    },
  },
};